// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"34":"fbf0b96e","425":"8b017829","510":"b602399e","532":"414d80e7","633":"c3017112","634":"b54da195","922":"e042756c","937":"71de5f91","972":"a8b2452d"}[chunkId] + ".chunk.js";
};